import { jsx as _jsx } from "react/jsx-runtime";
import useIconProps from '../utils/use-icon-props';
import useStrokeWidth from '../utils/use-stroke-width';
const Alimentation = (props) => {
    const iconProps = useIconProps(props);
    const strokeWidth = useStrokeWidth(iconProps.width);
    return (_jsx("svg", Object.assign({}, iconProps, { viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M8.43369 29V11.8125C8.43369 11.8125 2.33189 4 12.2473 4H23.688C34.3662 4 28.2643 11.8125 28.2643 11.8125V25.875C28.2643 27.6009 26.8985 29 25.2135 29H8.43369ZM8.43369 29H6.90826C5.22331 29 3.8574 27.6009 3.8574 25.875V11.8125C3.8574 11.8125 -2.24441 4 7.67098 4H13.01", stroke: "#2B2B2B", strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
export default Alimentation;
